import {POLICY_SERVICE} from "@/store/constants";

const POLICIES = "/policies/"

export default {
    namespaced: true,
    actions: {
        getPolicies({dispatch}, name) {
            return dispatch('API', POLICY_SERVICE, {root: true})
                .then(api => api.get(POLICIES + encodeURIComponent(name)))
                .then(result => (result.data.items))
        },
        savePolicy({dispatch}, policy) {
            return dispatch('API', POLICY_SERVICE, {root: true})
                .then(api => {
                    if (policy.id) {
                        return api.put(POLICIES + encodeURIComponent(policy.id), policy)
                    }
                    return api.post(POLICIES, policy)
                })
                .then(result => (result.data))
        },
        deletePolicy({dispatch}, name) {
            return dispatch('API', POLICY_SERVICE, {root: true})
                .then(api => api.delete(POLICIES + encodeURIComponent(name)))
                .then(result => (result.data))
        }
    }
}
